var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarTick(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 2.50016H15V0.833496H13.3333V2.50016H6.66667V0.833496H5V2.50016H4.16667C3.72464 2.50016 3.30072 2.67576 2.98816 2.98832C2.67559 3.30088 2.5 3.7248 2.5 4.16683V15.8335C2.5 16.2755 2.67559 16.6994 2.98816 17.012C3.30072 17.3246 3.72464 17.5002 4.16667 17.5002H8.33333V15.8335H4.16667V6.66683H15.8333V10.8335H17.5V4.16683C17.5 3.7248 17.3244 3.30088 17.0118 2.98832C16.6993 2.67576 16.2754 2.50016 15.8333 2.50016Z",
    fill: "#868686"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3649 17.5L10 15.1507L10.5965 14.5686L12.3754 16.3358L12.9614 16.9179L12.3649 17.5ZM14.7298 17.5L12.3649 15.1507L12.9509 14.5582L14.7298 16.3254L18.5807 12.5L19.1667 13.0925L14.7298 17.5ZM14.7298 15.1507L14.1334 14.5686L16.2053 12.5104L16.8017 13.0925L14.7298 15.1507Z",
    fill: "#868686"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarTick);
export default __webpack_public_path__ + "static/media/Calendar-tick.0e8bf8f4c926b7490c33490d92b84625.svg";
export { ForwardRef as ReactComponent };